module.exports = __webpack_public_path__ + "fonts/TTNormsPro-BoldItalic.0e908f7d.woff";